import { atom } from 'jotai';

export type ActionPanelTab = 'updates' | 'comments' | 'meetings' | 'files';

export const actionPanelActiveTabState = atom<ActionPanelTab>('updates');

export type ActionPanelContext = 'team' | 'project' | 'company';
export type ActionPanel = { context: ActionPanelContext; title: string };

export const actionPanelState = atom<ActionPanel | null>(null);

export const actionPanelOpenOnLoadState = atom<boolean>(false);

export const actionPanelScrollToParamState = atom<boolean>(false);
